import type { AxiosError } from "axios";

const LOGIN_ERROR_KEYS: Record<string, string> = {
  RSUSKO001: "loginPage.errors.wrongCredentials",
  RSUSKO010: "loginPage.errors.unavailable",
  RSUSKO014: "loginPage.errors.notActive",
  RSUSKO015: "loginPage.errors.noAccount",
  RSUSKO017: "loginPage.errors.tooManyAttempts",
  RSUSKO029: "loginPage.errors.banned",
  RSUSKO031: "loginPage.errors.emailDomain",
  RSUSERR403: "loginPage.errors.unavailable",
};

/**
 * UMD refuses a sign-in with a code and an English text written for developers: the person reads, in the language of
 * the page, the message of the code. In the clientView namespace.
 */
export const loginErrorKey = (error: unknown): string => {
  const code = (error as AxiosError<{ code?: string }> | undefined)?.response
    ?.data?.code;
  return (code && LOGIN_ERROR_KEYS[code]) || "loginPage.errors.generic";
};
